// Reads a WhatsApp template `components` array (Meta's format, whether it came from
// our own records or from a template synced straight from the Meta template manager)
// into the pieces needed to render a read-only preview.
export const parseTemplateComponents = (components = []) => {
  const list = Array.isArray(components) ? components : [];
  const header = list.find(component => component.type === 'HEADER');
  const body = list.find(component => component.type === 'BODY');
  const footer = list.find(component => component.type === 'FOOTER');
  const buttonsComponent = list.find(component => component.type === 'BUTTONS');

  return {
    headerText: header?.format === 'TEXT' ? header.text : '',
    headerMediaType: header && header.format !== 'TEXT' ? header.format : '',
    bodyText: body?.text || '',
    footerText: footer?.text || '',
    buttons: (buttonsComponent?.buttons || [])
      .map(button => button.text)
      .filter(Boolean),
  };
};

export const buildTemplatePreviewText = components => {
  const { headerText, headerMediaType, bodyText, footerText } =
    parseTemplateComponents(components);
  const parts = [];
  if (headerText) parts.push(headerText);
  if (headerMediaType) parts.push(`[${headerMediaType}]`);
  if (bodyText) parts.push(bodyText);
  if (footerText) parts.push(footerText);
  return parts.join('\n\n');
};
